module.exports = __webpack_public_path__ + "img/research_boat.b5bd1c07.jpg";